import posthtml from 'posthtml/lib';
export const ensureMjHead = mjml => {
  const ensureHead = tree => {
    tree.match({
      tag: 'mjml'
    }, mjmlElement => {
      let hasHead = false;
      tree.match({
        tag: 'mj-head'
      }, head => {
        hasHead = true;
        return head;
      });
      if (!mjmlElement.content) {
        mjmlElement.content = [];
      }
      if (!hasHead) {
        var _mjmlElement$content;
        (_mjmlElement$content = mjmlElement.content) == null || _mjmlElement$content.unshift({
          tag: 'mj-head'
        });
      }
      return mjmlElement;
    });
    return tree;
  };
  const withHead = posthtml([ensureHead]).process(mjml, {
    sync: true,
    xmlMode: true
  });
  return withHead.html;
};
//# sourceMappingURL=ensure-mj-head.js.map